import {DEFAULT_CLOSEAT, DEFAULT_OPENFROM} from "../app-consts/appConstants";
import { flow, keyBy, mapValues } from "lodash";
import { StateList } from '../utilities/StateList';

export const isSupportedRegion = (googleLocation, supportedRegions) => {
  const locationCountry = googleLocation.address_components?.filter(
    (component)=>component.types?.includes("country"))[0]?.short_name
  return supportedRegions?.includes(locationCountry)
}

export const getAddressForServiceRequestPayload = (addressDetails) => {
    let formattedAddress = {}
    formattedAddress.addressLine1 = getStreetInfoFromAddressComponents(addressDetails)
    if(addressDetails["neighborhood,political"]) formattedAddress.addressLine2 = addressDetails["neighborhood,political"];
    formattedAddress.city = getCityFromAddressComponents(addressDetails);
    formattedAddress.state = formatState(addressDetails["administrative_area_level_1,political"]);
    formattedAddress.zipCode = addressDetails["postal_code"];
    formattedAddress.country = addressDetails["country,political"];
    return formattedAddress;
}

export const parseAddressComponents = (addressComponents, property = 'short_name') => {
  const currentAddr = flow(
    x => keyBy(x, "types"),
    x => mapValues(x, property)
  )(addressComponents);
  return currentAddr;
}

export const getStreetInfoFromAddressComponents = (addressDetails) => {
  if(addressDetails['street_address']) return addressDetails['street_address']

  if (addressDetails['route']) {
    let streetInfo = ''
    if(addressDetails['street_number']) streetInfo += (addressDetails['street_number'] + ' ')
    streetInfo += (addressDetails['route'])
    if(addressDetails["subpremise"]) streetInfo += (', ' + addressDetails["subpremise"])
    return streetInfo.trim()
  }

  if (addressDetails.name) return addressDetails.name
  if (addressDetails.vicinity) return addressDetails.vicinity?.split(",")[0]
}

export const getCityFromAddressComponents = (addressDetails) => {
  let addressComponentKeys = Object.keys(addressDetails)

  let findKey = (addressComponentKeys, type1, type2) => {
    return addressComponentKeys.find((key) => {
      let types = key.split(',')
      if(type2) {
        return types.includes(type1) && types.includes(type1)
      } else {
        return types.includes(type1)
      }
    })
  }

  let cityKey = findKey(addressComponentKeys, 'locality') ||
    findKey(addressComponentKeys, 'administrative_area_level_3') ||
    findKey(addressComponentKeys, 'sublocality', 'sublocality_level_1') ||
    findKey(addressComponentKeys, 'neighborhood')

  return addressDetails[cityKey]
}

export const getLatLngAsValue = (location) => {
  if (!location) {
    return { lat: undefined, lng: undefined };
  }
  let {lat, lng} = location
  if (lat instanceof Function) {
    lat = lat();
    if (lng instanceof Function) {
      lng = lng();
    } else {
      window.datadogRum?.addError(new Error('getLatLngAsValue error pulling functions from location'))
    }
  }
  return {lat, lng}
}

export const setOpenFromCloseAtToDefaultIfMissing = (destinations) => {
  return destinations?.map(destination => {
    let openfrom = destination?.opening_hours?.openfrom
    let closeat = destination?.opening_hours?.closeat
    let opening_hours = {}
    if(!openfrom) {
      openfrom = DEFAULT_OPENFROM
    }
    if(!closeat) {
      closeat = DEFAULT_CLOSEAT
    }
    opening_hours.openfrom = openfrom;
    opening_hours.closeat = closeat;
    destination.opening_hours = opening_hours;
    return destination;
  })
}

export const getResultByTypeAndDistanceToCoords = (originatingCoords, geocodingResult) => {
  const filteredResults = geocodingResult?.filter(result => {
    return result.types?.includes("route")
      || result.types?.includes("establishment")
      || result.types?.includes("street_address")
      || result.types?.includes("premise")
  })

  if (filteredResults.length === 0) {
    return geocodingResult[0]
  }

  let distanceToResults
  try {
    distanceToResults = filteredResults
      .map(result => {
        result.distanceFromOrigin = window?.google?.maps?.geometry?.spherical?.computeDistanceBetween(originatingCoords, result?.geometry?.location);
        return result
      })
      .sort((a, b) => a.distanceFromOrigin - b.distanceFromOrigin)
  } catch (e) {
    return geocodingResult[0]
  }

  return distanceToResults[0]
}

export const geocodeAddress = (address, onSuccess, onError) => {
  try {
    const geocoder = new google.maps.Geocoder();
    if (!geocoder) {
      onError('Geocoder instance not created');
      return;
    }
    geocoder.geocode({ address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results?.[0]) {
        onSuccess(results[0]);
      } else {
        onError(status);
      }
    });
  } catch (e) {
    onError('Geocoder initialization failed: ' + e.message);
  }
};

export const formatState = (state = "") => {
  if (!state) {
    return;
  }
  if (state?.length > 2) {
    const stateFound = StateList.find((element) => {
      return element.text === state.toUpperCase();
    });
    return stateFound?.value;
  } else {
    return state;
  }
};
